import { ChangeDetectionStrategy, Component } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';

import { NewInvitationStore } from '@store';

@Component({
  selector: 'app-new-invitation',
  templateUrl: './new-invitation.component.html',
  styleUrls: ['./new-invitation.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class NewInvitationComponent {
  constructor(
    public dialogRef: MatDialogRef<NewInvitationComponent>,
    public newInvitationStore: NewInvitationStore
  ) {}

  onNewInvitation(request: { gatewaySerial: string; comment?: string }): void {
    this.newInvitationStore.createInvitation(request);
  }

  onClose(): void {
    this.dialogRef.close();
  }
}
